import {
  MEMBER_AUTH_LOADED,
} from 'WebsiteApp/modules/auth/AuthActions'

export function wallets(state = [], action) {
  switch(action.type) {
    case MEMBER_AUTH_LOADED:
     return action.payload.wallets || [];
  }
  return [...state];
}


export default wallets;



// WEBPACK FOOTER //
// ./src/modules/wallet/WalletReducers.js